import { render } from "./PageError404.vue?vue&type=template&id=ded5f99c"
import script from "./PageError404.vue?vue&type=script&lang=js"
export * from "./PageError404.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__